var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXrp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 64,
    height: 64,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2,2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,1c-34.74,0 -63,28.26 -63,63c0,34.74 28.26,63 63,63c34.74,0 63,-28.26 63,-63c0,-34.74 -28.26,-63 -63,-63zM64,7c31.43,0 57,25.57 57,57c0,31.43 -25.57,57 -57,57c-31.43,0 -57,-25.57 -57,-57c0,-31.43 25.57,-57 57,-57zM36.5,33.50195c-0.7675,0 -1.53414,0.29391 -2.11914,0.87891c-1.17,1.17 -1.17,3.06828 0,4.23828l16.88867,16.89063c3.4,3.4 7.92047,5.26953 12.73047,5.26953c4.81,0 9.33047,-1.86953 12.73047,-5.26953l16.88867,-16.89062c1.17,-1.17 1.17,-3.06828 0,-4.23828c-1.17,-1.17 -3.06828,-1.17 -4.23828,0l-16.89062,16.88867c-2.27,2.27 -5.28023,3.50977 -8.49023,3.50977c-3.21,0 -6.22023,-1.24977 -8.49023,-3.50977l-16.89062,-16.88867c-0.585,-0.585 -1.35164,-0.87891 -2.11914,-0.87891zM64,67.2207c-4.81,0 -9.33047,1.86953 -12.73047,5.26953l-16.88867,16.89063c-1.17,1.17 -1.17,3.06828 0,4.23828c1.17,1.17 3.06828,1.17 4.23828,0l16.89063,-16.88867c2.27,-2.27 5.28023,-3.50977 8.49023,-3.50977c3.21,0 6.22023,1.24977 8.49023,3.50977l16.89063,16.88867c0.59,0.59 1.34914,0.88086 2.11914,0.88086c0.77,0 1.53914,-0.29086 2.11914,-0.88086c1.17,-1.17 1.17,-3.06828 0,-4.23828l-16.88867,-16.89062c-3.4,-3.4 -7.92047,-5.26953 -12.73047,-5.26953z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/xrp.10c42aba71b7c7de54c82a8e82927b7b.svg";
export { ForwardRef as ReactComponent };